import angular from 'angular'
import directive from './directive'
import locker from './locker'
import uiStateManagerService from './uiStateManagerService'
import uiStateManagerMonitorService from './uiStateManagerMonitorService'
import uiStateManagerHistoryService from './uiStateManagerHistoryService'
import uiStateManagerServiceTestingData from './uiStateManagerServiceTestingData'
import uiStateChanger from './uiStateChanger.component'

export default angular
  .module('ellipsis.uiStateManager', [])
  .directive('uiStateManager', directive)
  .directive('uiStateManagerLocker', locker)
  .service('uiStateManagerService', uiStateManagerService)
  .service('uiStateManagerMonitorService', uiStateManagerMonitorService)
  .service('uiStateManagerHistoryService', uiStateManagerHistoryService)
  .service('uiStateManagerServiceTestingData', uiStateManagerServiceTestingData)
  .component('uiStateChanger', uiStateChanger)
